<template>
  <form @submit.prevent="onSubmit">
    <v-container>
      <v-row>
        <v-col cols="12" sm="6">
          <v-text-field label="Term*" v-model="term" required></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field label="Meaning" v-model="meaning"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn color="blue darken-1" text @click="onCancel">Cancel</v-btn>
          <v-btn type="submit" color="blue darken-1" text>Done</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </form>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["item", "studyList"]),
  data: () => ({
    term: "",
    meaning: ""
  }),

  methods: {
    onSubmit() {
      const payload = {
        id: this.item.id,
        term: this.term,
        meaning: this.meaning
      };

      this.$store.dispatch("updateItem", payload).then(() => {
        // this.inProgress = false;
        this.$router.push({
          name: "ItemDetail",
          params: { id: this.item.id }
        });
      });

      this.$store;
    },
    onCancel() {
      this.$router.push({
        name: "ItemDetail",
        params: { id: this.item.id }
      });
    }
  },
  created() {
    this.term = this.item.term;
    this.meaning = this.item.meaning;
  }
};
</script>
